import type { Edge, Node } from '@xyflow/react';
import { api } from '../api';

// One turn of the Workflow Assistant conversation. The chat is stateless on the
// backend: the full history is sent every turn (same shape as the V2 prototype).
export interface WorkflowAssistantTurn {
  role: 'user' | 'assistant';
  text: string;
}

export interface WorkflowAssistantResponse {
  action: 'reply' | 'build';
  message: string;
  // Present (and sanitized server-side) only when action === 'build'.
  workflow: { nodes: Node[]; edges: Edge[] } | null;
}

export const workflowAssistantService = {
  // Calls the Laravel endpoint that runs the LLM server-side (the front NEVER
  // talks to an AI SDK). The graph is already sanitized by the backend.
  async workflowAssistant(history: WorkflowAssistantTurn[], message: string): Promise<WorkflowAssistantResponse> {
    const res = await api.post('/workflows/assistant', { history, message });
    return (res.data as { data: WorkflowAssistantResponse }).data;
  },
};
